<script setup lang="ts"></script>

<template>
  <div class="flex flex-col gap-y-1.5">
    <slot />
  </div>
</template>

<style scoped></style>
